import { render, staticRenderFns } from "./EntityActions.vue?vue&type=template&id=e70854dc&scoped=true&"
import script from "./EntityActions.vue?vue&type=script&lang=js&"
export * from "./EntityActions.vue?vue&type=script&lang=js&"
import style0 from "./EntityActions.vue?vue&type=style&index=0&id=e70854dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70854dc",
  null
  
)

export default component.exports